module.exports = "pegasus_template/assets/theme5/large/1.jpg";